import type { WidgetProps } from '@rjsf/utils'
import { Mtds } from 'prove-common'

export const SelectWithSubTextWidget = ({
  disabled,
  id,
  onChange,
  options,
  placeholder,
  required,
  value
}: WidgetProps) => {
  const enumOptions = options.enumOptions
  const selectedValues = Array.isArray(value)
    ? new Set(value.map(String))
    : null
  const selected = enumOptions
    ?.filter((o) =>
      selectedValues
        ? selectedValues.has(String(o.value))
        : `${o.value}` === `${value}`
    )
    .map(({ label, value }) => ({ label, value: String(value) }))

  return (
    <div>
      <Mtds.Field.Suggestion
        selected={selected}
        onSelectedChange={([item]) => {
          onChange(
            enumOptions?.find((o) => `${o.value}` === `${item?.value}`)?.value
          )
        }}
      >
        <Mtds.Input
          disabled={disabled}
          id={id}
          placeholder={placeholder}
          required={required}
        />
        <button type='reset' aria-label='Fjern tekst' />
        <Mtds.Field.Datalist>
          {enumOptions?.map(({ label, value }) => (
            <Mtds.Field.Option key={value} value={value}>
              {label}
            </Mtds.Field.Option>
          ))}
        </Mtds.Field.Datalist>
      </Mtds.Field.Suggestion>
      {typeof options.undertext === 'string' ||
      typeof options.undertext === 'number' ? (
        <div style={{ marginTop: 4, color: '#888', fontSize: 12 }}>
          {options.undertext}
        </div>
      ) : null}
    </div>
  )
}
